var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "client"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter  fa-xs",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    staticClass: "btn-setting d-sm-down-none",
    staticStyle: {
      "padding-right": "10px"
    },
    on: {
      "click": _vm.addNewClient
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg"
  })])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('client.name')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('client.clientNamePlaceHolder')
    },
    model: {
      value: (_vm.clientname),
      callback: function($$v) {
        _vm.clientname = $$v
      },
      expression: "clientname"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('client.email')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-envelope'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('client.clientEmailPlaceHolder')
    },
    model: {
      value: (_vm.clientpersonemail),
      callback: function($$v) {
        _vm.clientpersonemail = $$v
      },
      expression: "clientpersonemail"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('client.mobileNo')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-mobile'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('client.clientMobileNoPlaceHolder')
    },
    model: {
      value: (_vm.clientpersonmobile),
      callback: function($$v) {
        _vm.clientpersonmobile = $$v
      },
      expression: "clientpersonmobile"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getClientSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(_vm._s(_vm.$t('inwardList.search')))]), _vm._v(" \n                  "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.reset')))])])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 s1 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('client.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6  s0 cardlistheader"
  }), _vm._v(" "), (_vm.resultCount > 0) ? _c('div', {
    staticClass: "col-md-2 s1 o3 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.count')) + " - " + _vm._s(_vm.resultCount))])]) : _vm._e()]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('client.clientId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('client.clientName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('client.status')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('client.action')))])])])]), _vm._v(" "), _c('tbody', [(!_vm.listClientData.length) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('client.cleintNotFoundError')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listClientData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(data.clientid))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.cstatus.trim() == 'active') ? _c('span', {
      staticClass: "badge badge-success",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getStatusRowData(data)
        }
      }
    }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (data.cstatus.trim() == 'inactive') ? _c('span', {
      staticClass: "badge badge-danger",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getStatusRowData(data)
        }
      }
    }, [_vm._v("Inactive")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-edit text-successedit fa-lg mt-2 ",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getClientRowData(data)
        }
      }
    })])])
  })], 2)])]), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listClientData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "no-close-on-backdrop": true,
      "no-fade": true
    },
    on: {
      "ok": function($event) {
        _vm.addclientmodal = false
      }
    },
    model: {
      value: (_vm.addclientmodal),
      callback: function($$v) {
        _vm.addclientmodal = $$v
      },
      expression: "addclientmodal"
    }
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.is_Loading
    },
    on: {
      "update:active": function($event) {
        _vm.is_Loading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [(_vm.clientaction == 'add') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(_vm._s(_vm.$t('client.addClient')))]) : _vm._e(), _vm._v(" "), (_vm.clientaction == 'edit') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(_vm._s(_vm.$t('client.editClient')) + " ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeAddClientModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('client.clientType')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('client.clientType')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addclient.clienttype),
      expression: "addclient.clienttype"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('clienttype')
    },
    attrs: {
      "id": "clienttype",
      "name": "clienttype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addclient.clienttype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('client.clientTypePlaceholder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "XB"
    }
  }, [_vm._v("XB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FC"
    }
  }, [_vm._v("FC")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('clienttype')),
      expression: "errors.has('clienttype')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientNameError')))])], 1)])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('client.clientBusinessInfo')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.clientName')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('client name')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('client.clientNamePlaceHolder'),
      "name": "client name",
      "id": "clientname"
    },
    model: {
      value: (_vm.addclient.clientname),
      callback: function($$v) {
        _vm.addclient.clientname = $$v
      },
      expression: "addclient.clientname"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('client name')),
      expression: "errors.has('client name')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientNameError')) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.clientPersonName')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('person name')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('client.clientPersonNamePlaceHolder'),
      "name": "person name",
      "id": "clientpersonname"
    },
    model: {
      value: (_vm.addclient.clientpersonname),
      callback: function($$v) {
        _vm.addclient.clientpersonname = $$v
      },
      expression: "addclient.clientpersonname"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('person name')),
      expression: "errors.has('person name')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientPersonError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.personEmail')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-envelope'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('email')
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('client.clientEmailPlaceHolder'),
      "name": "email",
      "id": "clientpersonemail"
    },
    model: {
      value: (_vm.addclient.clientpersonemail),
      callback: function($$v) {
        _vm.addclient.clientpersonemail = $$v
      },
      expression: "addclient.clientpersonemail"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.cleintEmailError')))])], 1)], 1)])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('client.clientPersonalInfo')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.address1')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-address-card'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('address')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('client.address1PlaceHolder'),
      "name": "address",
      "id": "clientaddress"
    },
    model: {
      value: (_vm.addclient.clientaddress),
      callback: function($$v) {
        _vm.addclient.clientaddress = $$v
      },
      expression: "addclient.clientaddress"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientAddress1Error')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.address2')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-address-card'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('address2')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('client.address2PlaceHolder'),
      "name": "address2",
      "id": "clientaddress2"
    },
    model: {
      value: (_vm.addclient.clientaddress2),
      callback: function($$v) {
        _vm.addclient.clientaddress2 = $$v
      },
      expression: "addclient.clientaddress2"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address2')),
      expression: "errors.has('address2')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address2')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.country')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-flag'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('country')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('client.countryPlaceHolder'),
      "id": "clientcountry"
    },
    model: {
      value: (_vm.addclient.clientcountry),
      callback: function($$v) {
        _vm.addclient.clientcountry = $$v
      },
      expression: "addclient.clientcountry"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('country')),
      expression: "errors.has('country')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientCountryError')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.state')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addclient.clientstate),
      expression: "addclient.clientstate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('state')
    },
    attrs: {
      "name": "state",
      "id": "state"
    },
    on: {
      "click": _vm.getCityList,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addclient.clientstate = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('client.statePlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listStateData), function(state_obj) {
    return _c('option', {
      domProps: {
        "value": state_obj.name
      }
    }, [_vm._v(_vm._s(state_obj.name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('state')),
      expression: "errors.has('state')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientStateError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.city')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-globe'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addclient.clientcity),
      expression: "addclient.clientcity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('city')
    },
    attrs: {
      "id": "city",
      "name": "city"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addclient.clientcity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('client.cityPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listCityData), function(city_obj) {
    return _c('option', {
      domProps: {
        "value": city_obj.city_name
      }
    }, [_vm._v(_vm._s(city_obj.city_name))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('city')),
      expression: "errors.has('city')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientCityError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('client.pinCode')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|max:6'),
      expression: "'required|numeric|max:6'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('pincode')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('client.pinCodePlaceHolder'),
      "name": "pincode",
      "id": "pincode"
    },
    model: {
      value: (_vm.addclient.clientpincode),
      callback: function($$v) {
        _vm.addclient.clientpincode = $$v
      },
      expression: "addclient.clientpincode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pincode')),
      expression: "errors.has('pincode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientPinCodeError')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.clientPersonMobileNumber')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-mobile'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|max:10'),
      expression: "'required|numeric|max:10'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('mobile number')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('client.clientPersonMobileNumberPlaceHolder'),
      "name": "mobile number",
      "id": "mobile"
    },
    model: {
      value: (_vm.addclient.clientpersonmobile),
      callback: function($$v) {
        _vm.addclient.clientpersonmobile = $$v
      },
      expression: "addclient.clientpersonmobile"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mobile number')),
      expression: "errors.has('mobile number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.cleintMobileNumberError')) + " ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.clientPersonMobileNumber1')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-phone'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|max:9'),
      expression: "'required|numeric|max:9'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('phone number')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('editedjson.PersonPhNumberPlaceHolder'),
      "name": "phone number",
      "id": "clientpersonphone"
    },
    model: {
      value: (_vm.addclient.clientpersonphone),
      callback: function($$v) {
        _vm.addclient.clientpersonphone = $$v
      },
      expression: "addclient.clientpersonphone"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone number')),
      expression: "errors.has('phone number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.cleintMobileNumberError')) + " ")])], 1)], 1)])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('client.clientGovtInfo')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.clientRegistrationNumber')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-registered'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('register number')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('client.clientRegistrationNumberPlaceHolder'),
      "name": "register number",
      "id": "clientregisternum"
    },
    model: {
      value: (_vm.addclient.clientregisternum),
      callback: function($$v) {
        _vm.addclient.clientregisternum = $$v
      },
      expression: "addclient.clientregisternum"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('register number')),
      expression: "errors.has('register number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientRegistrationNumberError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.clientPanNumber')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-drivers-license'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('panNumber')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('client.clientPanNumberPlaceHolder'),
      "name": "panNumber",
      "id": "clientpanNumber"
    },
    on: {
      "change": _vm.validatePan
    },
    model: {
      value: (_vm.addclient.clientpanid),
      callback: function($$v) {
        _vm.addclient.clientpanid = $$v
      },
      expression: "addclient.clientpanid"
    }
  })], 1), _vm._v(" "), (_vm.pancheck == 1) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientPanNumberError')))]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('panNumber')),
      expression: "errors.has('panNumber')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientPanNumberError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.clientGstNumber')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('gst number')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('client.clientGstNumberPlaceHolder'),
      "name": "gst number",
      "id": "clientgstnum"
    },
    on: {
      "change": _vm.validateGst
    },
    model: {
      value: (_vm.addclient.clientgstnum),
      callback: function($$v) {
        _vm.addclient.clientgstnum = $$v
      },
      expression: "addclient.clientgstnum"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('gst number')),
      expression: "errors.has('gst number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientGSTNumberError')))])], 1)], 1)])]), _vm._v(" "), (_vm.clientaction == 'add') ? _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('client.clientGovtInfo')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.clientcodename')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-envelope'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('clientcodename')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('client.clientCodeNamePlaceholder'),
      "title": "name displayed in client dropdown",
      "name": "clientcodename",
      "id": "clientcodename"
    },
    model: {
      value: (_vm.addclient.clientcodename),
      callback: function($$v) {
        _vm.addclient.clientcodename = $$v
      },
      expression: "addclient.clientcodename"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('clientcodename')),
      expression: "errors.has('clientcodename')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientcodeNameError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.clietnDBName')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('clietnDBName')
    },
    attrs: {
      "type": "text",
      "pattern": "[A-Z]\\w*DB",
      "title": "eg.AceturtleDB   Must have first letter Capital and postfix as DB ",
      "placeholder": _vm.$t('client.clientDBNamePlaceHolder'),
      "name": "clietnDBName",
      "id": "clietnDBName"
    },
    model: {
      value: (_vm.addclient.clietnDBName),
      callback: function($$v) {
        _vm.addclient.clietnDBName = $$v
      },
      expression: "addclient.clietnDBName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('clietnDBName')),
      expression: "errors.has('clietnDBName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientDBNameError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.pool')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('pool')
    },
    attrs: {
      "type": "number",
      "title": "Enter Pool size",
      "placeholder": _vm.$t('client.clientPoolPlaceHolder'),
      "name": "pool",
      "id": "pool"
    },
    model: {
      value: (_vm.addclient.pool),
      callback: function($$v) {
        _vm.addclient.pool = $$v
      },
      expression: "addclient.pool"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pool')),
      expression: "errors.has('pool')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientPoolError')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.clientLoginUserName')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-envelope'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('clientloginemail')
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('client.clientLoginUserNamePlaceHolder'),
      "name": "clientloginemail",
      "id": "clientloginemail"
    },
    model: {
      value: (_vm.addclient.clientloginemail),
      callback: function($$v) {
        _vm.addclient.clientloginemail = $$v
      },
      expression: "addclient.clientloginemail"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('clientloginemail')),
      expression: "errors.has('clientloginemail')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientLoginUserNameError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('client.clientPassword')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('password')
    },
    attrs: {
      "type": "password",
      "pattern": "(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}",
      "title": "Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters",
      "placeholder": _vm.$t('client.clientPasswordPlaceHolder'),
      "name": "password",
      "id": "password"
    },
    model: {
      value: (_vm.addclient.password),
      callback: function($$v) {
        _vm.addclient.password = $$v
      },
      expression: "addclient.password"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('client.clientPasswordError')))])], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clientfooter form-actions"
  }, [(_vm.clientaction == 'add') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.is_Loading
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))]) : _vm._e(), _vm._v(" \n              "), _vm._v(" "), (_vm.clientaction == 'edit') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": _vm.is_Loading
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('printProductDetails.update')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeAddClientModal
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.cancelBtn')))])])])], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false
      }
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pincodemapping.confirmation')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusClientModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('editedjson.changeStatusClient')) + " " + _vm._s(_vm.changestatus) + " " + _vm._s(_vm.$t('editedjson.changeStatusClient1')) + "?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.changeClientStatus, function($event) {
        _vm.modalShow = false
      }]
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('warehouses.saveChangesBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusClientModal
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("  " + _vm._s(_vm.$t('common.cancelBtn')))])])])])])])])])], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-57b9606a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57b9606a","hasScoped":true}!./src/views/components/client/client.component.html
// module id = 1064
// module chunks = 0